/* eslint-disable */
/* jscs:disable */
import { createRouter, createWebHashHistory } from 'vue-router';
import Home from './views/Home.vue';
import Store from './store';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'index',
            component: Home
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            beforeEnter: (to, from, next) => {
                for (const key in to.query) {
                    if (to.query.hasOwnProperty(key)) {
                        const query = to.query[key];

                        switch (key) {
                            // case 'fiscalYear':
                            //     Store.commit('setSelectedYear', query);
                            //     break;
                            case 'facet':
                                Store.commit('setSelectedFacet', query);
                                break;
                            case 'single':
                                Store.commit('setSingleStudiesFilter', query);
                                break;
                            case 'rcdcFilter':
                                Store.commit('setRcdcFilterValue', query);
                                break;
                            case 'rcdcCategory':
                                Store.commit('setSelectedRcdc', query);
                                break;
                            case 'ic':
                                Store.commit('setSelectedIcFilter', query);
                                break;
                        }
                    }
                }
                next();
            }
        },
        {
            path: '/rcdc',
            name: 'rcdc',
            component: () => import ('./views/Rcdc.vue'),
            beforeEnter: (to, from, next) => {
                for (const key in to.query) {
                    if (to.query.hasOwnProperty(key)) {
                        const query = to.query[key];

                        switch (key) {
                            case 'rcdcCategory':
                                Store.commit('setSelectedRcdc', query);
                                break;
                        }
                    }
                }
                next();
            }
        },
        {
            path: '/ic',
            name: 'ic',
            component: () => import ('./views/Ic.vue'),
            beforeEnter: (to, from, next) => {
                for (const key in to.query) {
                    if (to.query.hasOwnProperty(key)) {
                        const query = to.query[key];

                        switch (key) {
                            case 'rcdcCategory':
                                Store.commit('setSelectedRcdc', query);
                                break;
                            case 'ic':
                                Store.commit('setSelectedIc', query);
                                break;
                            // case 'fiscalYear':
                            //     Store.commit('setSelectedYear', query);
                            //     break;
                        }
                    }
                }
                next();
            }
        }
    ]
});

export default router;